export const HEADER = "طلبات السحب";
export const PENDING_WITHDRAWS_TAB = "بانتظار التحويل";
export const FINISHED_WITHDRAWS_TAB = "تم التحويل";
export const BUTTON = {
  SEARCH: "بحث بكود المستخدم أو كود المعامله",
  SEARCH_USER: "بحث باسم المستخدم",
  SEARCH_TRANSACTION: "بحث بكود المعامله",
};
export const TABLE_HEADERS = {
  USER_NAME: "المستخدم",
  REQUEST_TIME: "وقت الطلب",
  AMOUNT: "القيمة",
  STATUS: "الحالة",
};

export enum WITHDRAW_STATUS {
  INITIATED = "INITIATED",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  FAILED = "FAILED",
}
